import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy, AfterViewChecked,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef, NgZone
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_ru_RU from "@amcharts/amcharts4/lang/ru_RU"
import {ChartData} from "../../models/chart-data";
import * as moment from "moment";
import {ChartLineModel} from "../../models/amchart/chart-line-model";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {
    ChartAggDataBuffer,
    ChartAggDataSales,
    ChartAggDatesModel,
    ChartAggModel
} from "../../models/amchart/chart-aggregation";
import {BufferGraphService} from "../../services/buffer-graph.service";
import {ChartSetDataModel} from "../../models/amchart/chart-exchange";
import {ChartListProps} from "../../models/amchart/chart-list-props";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {StocksFilter} from "../../../stocks/models/stocks-filter";
import {ChartPeriodSelectorComponent} from "../chart-period-selector.component/chart-period-selector.component";
import {AddItemsItem} from "../../../orders/models/add-items-item";
import {AddChartModel} from "../../models/amchart/add-chart-model";
import {CompareItem} from "../../models/compare-item";
import * as Popper from 'popper.js/dist/umd/popper';
import {Formatters} from "../../../slick-grid/models/formatters";
import {CodeName} from "../../../stocks/models/code-name";
import {CodeNameChartTabs} from "../../models/code-name-chart-tabs";
import Timer = NodeJS.Timer;
import {CommonService} from "../../../services/common.service";

am4core.useTheme(am4themes_animated);


@Component({
    selector: 'amchart4',
    templateUrl: './amchart4.component.html',
    styleUrls: ['./amchart4.component.css', '../../../../../node_modules/animate.css/animate.min.css']
})
export class Amchart4Component implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly graphService: BufferGraphService,
                public readonly commonData: CommonDataService,
                private readonly dataExchange: BufferGraphDataExchangeService,
                private commonService: CommonService,
                private readonly zone: NgZone){


        this.initialise();
        //this.setChartProps();
        this.translateService.get(['NoData', 'Date', 'OffShort', 'OnShort']).subscribe(t => this.translates = t);
    }

    private initialise = (): void =>{
        this.legendVisible = false;
        this.helper = new ChartHelper();
        this.lines = {};
        this.bubbleLines = {};
        this.info = [];
        this.agg = [];
        this.lgHeight = 0;
        this.bubbleVisible = true;
        this.cwhItemId = 0;
        this.compareItems = [];
        this.closeOut = new EventEmitter<boolean>();
        this.loading = new EventEmitter<boolean>();
        this.customListsPopper = null;
        this.hideCompareBtn = true;
        this.showAgg = true;
        //this.isMainChart= true;
    };

    @Input() public chartData: ChartData;

    @Input() public isAdmin: boolean;

    @Input() public type: string;

    @Input() private GUID: string;

    @Input() private sharedGUID?: string;

    @Input() private isMainChart: boolean;

    @Input()
    private set wrpWidth(val: number){
        this.chartWrpWidth = val;
    };

    @Output()
    private closeOut: EventEmitter<boolean>;

    @Output()
    private loading: EventEmitter<boolean>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('legenddiv')
    private legenddiv: ElementRef;

    @ViewChild('wrhListBtn')
    private wrhListBtn: ElementRef;

    @ViewChild('tabsListBtn')
    private tabsListBtn: ElementRef;

    @ViewChild('customListBtn')
    private customListBtn: ElementRef;

    @ViewChild('customListAnchor')
    private customListAnchor: ElementRef;

    @ViewChild('customListsWrp')
    private customListsWrp: ElementRef;

    @ViewChild('showCompBtn')
    private showCompBtn: ElementRef;

    @ViewChild('btnWrpCompare')
    private btnWrpCompare: ElementRef;

    @ViewChild('chartHeader')
    private chartHeader: ElementRef;

    @ViewChild('chartPeriodSelector')
    private chartPeriodSelector: ChartPeriodSelectorComponent;

    private subscriptionShowTargetLevel: ISubscription;
    private subscriptionUpdateChartData: ISubscription;
    private subscriptionToggleBubbleChart: ISubscription;
    private subscriptionToggleChartInfo: ISubscription;
    private subscriptionUpdateChartZoom: ISubscription;
    private subscriptionUpdateCustomChartPopper: ISubscription;
    private subscriptionUpdateLineVisibility: ISubscription;
    private subscriptionCompareChartReady: ISubscription;
    private subscriptionSetGlass: ISubscription;

    // private chart: am4charts.XYChart;
    private chart: any;
    // private bubbleChart: am4charts.XYChart;
    private bubbleChart: any;
    // private info: any;
    private info: ChartLineModel[];
    private infoBubble: ChartLineModel[];
    private lines: any;
    private bubbleLines: any;
    private bubbleChartData: any[];
    public chartLines: ChartLineModel[];
    public bubbleChartLines: ChartLineModel[];
    private bubbleChartXAxix: any;
    private bubbleChartYAxix: any;
    private chartXAxix: any;
    private chartYAxix: any;
    private chartYAxix2: any;
    private bubbleChartCursor: any;
    private helper: ChartHelper;
    private agg: ChartAggModel[];
    private aggPeriod: string;
    public legendVisible: boolean;
    public legendBubbleVisible: boolean;
    public _bubbleVisible: boolean;
    private translates: any;
    private listenResize: () => void;
    private lgHeight: number;
    private sku: string;
    private warehouseCode: string;
    private itemId: number;
    public showInfo: boolean;
    private cwhItemId: number;
    private compareItems: CompareItem[];
    private chartReady: boolean;
    private bubbleChartReady: boolean;
    public showWrhList: boolean;
    public showCustomLists: boolean;
    private addItemGUID: string;
    public stpDate: string;
    public hideCompareBtn: boolean;
    public showAgg: boolean;
    public rightAxis: boolean;
    public _chartWrpWidth: number;
    public showGlass: boolean;

    private customListsPopper: Popper;
    private customListsPopperCreate: boolean;
    public compareButtonsPopperUpdate: boolean;
    private compareButtonsPopper: Popper;
    public showTabsList: boolean;
    private CTRLPressed: boolean;
    public freezeDataChange: boolean;
    public id: string;
    public savedRange: any;
    public savedZoom: {start: Date, end: Date};

    public interval: Timer;


    // public tabs: CodeNameChartTabs;

    @HostListener('document:resize', ['$event'])
    private onResize = (): void =>{
        if (this.customListsPopper){
            this.customListsPopper.update();
        }
    }

    @HostListener('document:keyup', ['$event'])
    private onKeyUp = (e: KeyboardEvent): void =>{
        this.CTRLPressed = e.ctrlKey;
    }

    @HostListener('document:keydown', ['$event'])
    private onKeyDown = (e: KeyboardEvent): void =>{
        this.CTRLPressed = e.ctrlKey;
    }

    async ngOnInit(){
        this.id = this.type + 'Chart' + this.isMainChart ? 'Main' : '';
        this.chartLines = await this.helper.genChartProps(this.translateService, this.commonService, this.isAdmin);
        this.bubbleChartLines = await this.helper.genBubbleChartProps(this.translateService, this.commonService, this.isAdmin);

        for (let i = 0; i < this.chartLines.length; i++){
            if (this.chartLines[i].name === 'actionBuffer'){
                this.chartLines[i].lineNamePopup = await this.translateService.get('MainChart_BufferGAll').toPromise();
            } else if (this.chartLines[i].name === 'actionSafetyBuffer'){
                this.chartLines[i].lineNamePopup = await this.translateService.get('MainChart_ActionSafetyBufferAll').toPromise();
            }
        }

        if (!this.GUID){
            // this.GUID = this.helper.generateGUID();
            // this.isMainChart = false
        } else{
            this.addItemGUID = this.helper.generateGUID();
            this.addToListProps(this.addItemGUID);
        }

        this.updateLegends();


        // this.listenResize = this.renderer.listen('body', 'resize', this.updateLgHeight);
        this.generateBubbleChartData();
        this.sku = this.chartData.itemInfo.sku;
        this.warehouseCode = this.chartData.itemInfo.warehouseCode;
        this.itemId = this.chartData.itemInfo.itemId;

        this.addToListProps();
        this.updateCWHItemId();

        if (this.type === 'main'){
            this.showInfo = true;
        }
        console.log(this.chartData, 'ngOnInit');
        // console.warn(this.chartData.rows[0], 'this.data.rows[0]');
    }

    ngAfterViewInit(){
        this.zone.runOutsideAngular(() =>{
            this.interval = setInterval(() =>{
                if (this.chartLines && this.bubbleChartLines && this.chartLines.length && this.bubbleChartLines.length){
                    clearInterval(this.interval);
                    this.interval = null;
                    // this.helper.wait(() => {
                        this.generateGraph();
                        this.generateBubbleChart2();



                    // }, 1000)

                    //# show target level on chart
                    this.subscriptionShowTargetLevel = this.dataExchange.showTargetLevelCurrent.subscribe(r =>
                        this.helper.tryCatch(() => r !== null ? this.showTargetLevel(r) : null)
                    );
                    //# update chart data
                    this.subscriptionUpdateChartData = this.dataExchange.updateChartDataCurrent.subscribe(r => this.helper.tryCatch(() => this.updateChartData(r)));
                    //# toggle visibility bubble chart for main and compare chart
                    this.subscriptionToggleBubbleChart = this.dataExchange.toggleBubbleChartCurrent.subscribe((r: { type: string, sharedGUID: string, show: boolean }) =>
                        this.helper.tryCatch(() => r && (this.type === r.type || this.sharedGUID === r.sharedGUID) ? this.bubbleVisible = r.show : null)
                    );

                    //# toggle visibility info for main and compare chart
                    this.subscriptionToggleChartInfo = this.dataExchange.toggleChartInfoCurrent.subscribe((r: { type: string, sharedGUID: string, show: boolean }) =>
                        this.helper.tryCatch(() =>{
                            r && (this.type === r.type || this.sharedGUID === r.sharedGUID) ? this.showInfo = r.show : null;
                            //this need to be done
                            this.chartWrpWidth = Math.random() * 1000;
                        })
                    );

                    //# update zoom for main and compare chart
                    this.subscriptionUpdateChartZoom = this.dataExchange.updateChartZoomCurrent.subscribe((r: { type: string, sharedGUID: string, start: Date, end: Date }) =>
                        this.helper.tryCatch(() => r && (this.type === r.type || this.sharedGUID === r.sharedGUID) ? this.updateZoom(r.start, r.end) : null)
                    );

                    //# update popper for
                    this.subscriptionUpdateCustomChartPopper = this.dataExchange.customChartPopperUpdateCurrent.subscribe(r =>
                        this.helper.tryCatch(() => r && this.customListsPopper ? this.popperUpd() : null)
                    );

                    //# toggle visibility lines in charts, main and compare chart
                    this.subscriptionUpdateLineVisibility = this.dataExchange.toggleLinesVisibilityCurrent.subscribe(r =>
                        this.helper.tryCatch(() => this.updateLineVisibility(r))
                    );

                    //# sync in compare chart lines and props
                    this.subscriptionCompareChartReady = this.dataExchange.compareChartReadyCurrent.subscribe(
                        (r: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }) =>
                            this.helper.tryCatch(() =>
                                r ? r.command === 'ready' && r.sharedGUID === this.sharedGUID
                                    ? this.sendLinesPropsToCompareChart(r)
                                    : this.setLinesProps(r)
                                  : null
                            )
                    );

                    //# toggle visibility lines in charts, main and compare chart
                    this.subscriptionSetGlass = this.dataExchange.glassCurrent.subscribe((r: {sharedGUID: string, showGlass: boolean}) =>
                        this.helper.tryCatch(() =>  r && r.sharedGUID === this.sharedGUID ? this.showGlass = r.showGlass : null)
                    );

                    //# if Height too small hide bubble chart, or get property from localStorage
                    this.helper.wait(() => {
                        let bubbleVisibleLocal = localStorage[this.type + 'bubbleVisible'];
                        if (typeof bubbleVisibleLocal === 'undefined' && document.body.offsetHeight < 650){
                            this._bubbleVisible = false;
                        } else if (typeof bubbleVisibleLocal === 'undefined'){
                            this._bubbleVisible = true;
                        } else {
                            this._bubbleVisible = (bubbleVisibleLocal === 'true');
                        }
                    });

                    $(`#${this.id} [data-toggle="tooltip"]`).tooltip({trigger: 'hover', offset: "50px, 0", template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'})

                    // this.comparePopperAdd();
                }

            }, 100)

            this.chartWrpWidth = this.mainWrapper.nativeElement.offsetWidth;

            //this.generateGraph();
            //this.generateBubbleChart2();
        });


    }

    ngOnDestroy(){
        this.zone.runOutsideAngular(() =>{
            if (this.chart){
                this.chart.dispose();
            }

            if (this.bubbleChart){
                this.bubbleChart.dispose();
            }
        });

        this.subscriptionShowTargetLevel.unsubscribe();
        this.subscriptionUpdateChartData.unsubscribe();
        this.subscriptionToggleBubbleChart.unsubscribe();
        this.subscriptionToggleChartInfo.unsubscribe();
        this.subscriptionUpdateChartZoom.unsubscribe();
        this.subscriptionUpdateCustomChartPopper.unsubscribe();
        this.subscriptionUpdateLineVisibility.unsubscribe();
        this.removeFromListProps();
        this.removeFromListProps(this.addItemGUID);
        this.compareButtonsPopper ? this.compareButtonsPopper.destroy() : null;

        this.chart = null;
        this.bubbleChart = null;
        this.lines = null;
        this.bubbleLines = null;

        // this.listenResize();
    }

    ngAfterViewChecked(){
        if (this.customListsPopperCreate){
            this.customListsPopperCreate = false;
            this.popperAdd();
        }

        if (this.compareButtonsPopperUpdate){
            this.compareButtonsPopperUpdate = false;
            this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        }

    }

    public set chartWrpWidth(val: number){
        this.helper.wait(() => this._chartWrpWidth = val);
    };

    public get chartWrpWidth(): number{
        return this._chartWrpWidth
    }

    public set bubbleVisible(val: boolean){
        if (this._bubbleVisible !== val){
            this._bubbleVisible = val;
            localStorage[this.type + 'bubbleVisible'] = val;
        }
    }

    public get bubbleVisible(): boolean{
        return this._bubbleVisible
    }

    /*public genKeysForTranslate = (data: ChartLineModel[]): { key: string, name: string, translate: string }[] =>{
        return data.map(item =>{
            return {key: 'Chart_' + this.helper.upperCaseFirstLetter(item.name), name: item.name, translate: ''};
        });
    };*/

    /*private setTranslates = (keys: { key: string, name: string, translate: string }[], data: ChartLineModel[], t: any): void =>{
        keys.forEach(item =>{
            data.forEach(inItem =>{
                if (item.name === inItem.name){
                    inItem.lineName = t[item.key];
                }
            })
        })
    };*/
    //# update and sort legends for line and bubble chart
    private updateLegends = (): void =>{
        this.info = this.chartLines.filter(item => item);
        this.info.sort(function (a: ChartLineModel, b: ChartLineModel){
            return a.position - b.position;
        });

        // let idx = this.info.findIndex(item => item.name === 'bufferG');
        //
        // if (idx > -1){
        //
        //     let item = this.info.splice(idx, 1);
        //     this.info.unshift(item[0])
        // }

        this.infoBubble = this.bubbleChartLines.filter(item => !item.hideLineInLegend);
        this.infoBubble.sort(function (a: ChartLineModel, b: ChartLineModel){
            return a.position - b.position;
        });
    };

    //# update line visibility for line chart
    private updateChartLines = (): void =>{
        this.info.forEach(item =>{
            item.enabled ? this.lines[item.name].show() : this.lines[item.name].hide();
        });
    };

    //# update list of warehouses where this this SKU presents and itemId of this SKU on central warehouse
    private updateCWHItemId = (): void =>{
        if (!this.isMainChart){
            return;
        }

        this.graphService.getCompareData(this.itemId).subscribe(data =>{
            if (data == null || data.accessDenied)
                return;

            this.cwhItemId = data.cwhItemId;
            this.compareItems = data.items;
        });
    };

    //# create filter for custom add chart form
    private addToListProps = (GUID?: string): void =>{
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            filter = new StocksFilter();
        if (!GUID){
            filter.skus = [this.chartData.itemInfo.sku];
            filter.warehouses = [this.chartData.itemInfo.warehouseCode];
        }

        chartListProps.push(new ChartListProps(GUID ? GUID : this.GUID, filter));
        this.dataExchange.setChartListProps(chartListProps);
    };

    //# remove filter for custom add chart form
    //TODO move this function to buffer-graph component
    private removeFromListProps = (GUID?: string): void =>{
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            idx = chartListProps.findIndex(item => item.GUID === (GUID ? GUID : this.GUID));

        if (idx > -1){
            chartListProps.splice(idx, 1);
            this.dataExchange.setChartListProps(chartListProps);
        }
    };

    //# generate line chart
    private generateGraph = (): void =>{
        let t0 = performance.now();
        am4core.useTheme(am4themes_animated);
        //am4core.useTheme(am4themes_material);
        this.chart = am4core.create(this.GUID, am4charts.XYChart);
        this.chart.resizable = true;
        // this.chart.width = am4core.percent(100);
        // this.chart.height = am4core.percent(100);

        // set locales
        // console.log(this.data.rows[0].date.format('dd:'), 'generateGraph');

        //# set data
        this.chart.data = this.chartData.rows;



        // this.chart.dataSource.url = "/registry/getdata?Id=" + document.getElementById("ItemId").value + "&Days=" + document.getElementById("Days").value;
        // this.chart.dataSource.parser = new am4core.JSONParser();
        this.chart.padding(15, 0, 0, 10);

        //# set locale
        // TODO set other lang locales
        if (this.translateService.currentLang === 'ru'){
            // this.helper.wait(() => {
            this.chart.language.locale = am4lang_ru_RU;
        } else{
            //this.chart.dateFormatter.dateFormat = "yyyy-MM-dd";
        }

        //# Create axes
        this.chartXAxix = this.chart.xAxes.push(new am4charts.DateAxis());
        this.chartYAxix = this.chart.yAxes.push(new am4charts.ValueAxis());
        this.chartYAxix2 = this.chart.yAxes.push(new am4charts.ValueAxis());
        this.chartYAxix.renderer.minGridDistance = 30;
        this.chartXAxix.renderer.axisFills.interactionsEnabled = true;
        this.chartYAxix.renderer.axisFills.interactionsEnabled = true;
        this.chartYAxix2.renderer.axisFills.interactionsEnabled = true;

        this.chartYAxix2.renderer.opposite = true;
        this.chartYAxix2.renderer.labels.template.fill = am4core.color("#e3000f");
        this.chartYAxix2.renderer.grid.template.strokeOpacity = 1;
        this.chartYAxix2.renderer.grid.template.stroke = am4core.color("#e3000f");
        this.chartYAxix2.renderer.grid.template.strokeWidth = 1;
        this.chartYAxix2.min = 0;

        this.chartYAxix.keepSelection = true;
        this.chartYAxix.start = 0;
        this.chartYAxix.end = 1;
        this.chartYAxix2.start = 0;
        this.chartYAxix2.end = 1;

        //# set date display format for chart
        this.setDatesDisplayProps(this.chart, this.chartXAxix);

        //# change zoom on other charts
        const dateAxisChanged = (ev) =>{
            let start = new Date(ev.target.minZoomed),
                end = new Date(ev.target.maxZoomed);

            // if (this.bubbleVisible){
            // console.log('dateAxisChanged')
            this.chart.cursor.selection.hide();
            this.savedZoom = {start, end};
            this.bubbleChartXAxix.zoomToDates(start, end);
            this.dataExchange.setUpdateChartZoom({type: this.type, sharedGUID: this.sharedGUID, start: start, end: end})
            // }

        };

        if (!this.isMainChart){
            this.chart.zoomOutButton.disabled = true;
        }

        if (this.isMainChart){
            this.chartXAxix.events.on("startchanged", dateAxisChanged);
            this.chartXAxix.events.on("endchanged", dateAxisChanged);
        }

        //# add lines to line chart
        this.chartLines.forEach((item, i) =>{
            this.addLineWithOptions(item.name, item.color, item.areaFilledOnLine, item.showBulletOnLine, item.hideLineInLegend, item.showLineByDefault, item.lineName, i);
        });

        //# custom logic for some lines toggling visibility
        this.lines.valueOut.events.on("shown", () =>{
            this.lines.qntOut1.hide();
            this.disableLegend('qntOut1');
            this.lines.qntOut2.hide();
            this.disableLegend('qntOut2');
            this.lines.discountQnt.hide();
            this.disableLegend('discountQnt');
        });

        this.lines.qntOut1.events.on("shown", () =>{
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        this.lines.qntOut2.events.on("shown", () =>{
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        this.lines.discountQnt.events.on("shown", () =>{
            this.lines.valueOut.hide();
            this.disableLegend('valueOut');
        });

        this.addCursor();
        this.chart.legend = new am4charts.Legend();

        //# container for legends
        const resizeLegend = (ev): void =>{
            document.getElementById('legenddiv-' + this.GUID).style.height = this.chart.legend.contentHeight + "px";
            //this.lgHeight = this.legenddiv.nativeElement.offsetHeight;
            //console.log(this.chart.legend.contentHeight, 'this.chart.legend.contentHeight')
        };

        let legendContainer = am4core.create('legenddiv-' + this.GUID, am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        this.chart.legend.parent = legendContainer;

        this.chart.events.on("appeared", resizeLegend);
        this.chart.events.on("sizechanged", resizeLegend);

        this.chart.legend.useDefaultMarker = true;

        let marker = this.chart.legend.markers.template.children.getIndex(0);
        marker.adapter.add("fill", this.legendColors);

        //# Set up number format
        this.chart.numberFormatter.numberFormat = "#,###.00";

        //# initiate chart
        this.chart.events.on("ready", (ev) =>{
            this.chartReady = true;
            document.getElementById('legenddiv-' + this.GUID).style.height = this.chart.legend.contentHeight + "px";
            this.chartLines.forEach(item =>{
                if (!item.showLineByDefault){
                    this.lines[item.name].show();
                    this.lines[item.name].hide();
                }
            });

            // console.log('this.chart.events.on"ready"')



            this.updateStaticPopup();
            this.bufferAgg(this.savedRange);
            this.salesAgg(this.savedRange);
            if (!this.isMainChart){
                this.dataExchange.setCompareChartReady({
                    command: 'ready',
                    type: this.type,
                    sharedGUID: this.sharedGUID,
                    lines: null
                })
            }


            // this.commonData.showLoadingImg = false;
        });



        //# Aggregation Init
        this.helper.wait(() =>{

        });

        //# Aggregation Init
        this.chart.events.on("validated", (ev) =>{
            // console.log('this.chart.events.on"validated"')
            if (this.chartReady){
                // console.log(this.savedZoom, this.chartData.startDate, this.chartData.endDate, 'this.savedZoom, this.chartData.startDate, this.chartData.endDate')
                if (this.savedZoom && (this.chartData.startDate.toDate() <= this.savedZoom.start || this.chartData.endDate.toDate() >= this.savedZoom.end) ){
                    this.chartXAxix.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                    this.bubbleChartXAxix.zoomToDates(this.savedZoom.start, this.savedZoom.end);
                }
                this.helper.wait(() => {
                    this.updateChartLines();
                    this.updateStaticPopup();
                    this.bufferAgg(this.savedRange);
                    this.salesAgg(this.savedRange);
                }, 10)
            }
        });

        // zoom scrollbar
        if (this.isMainChart){
            this.chart.scrollbarX = new am4charts.XYChartScrollbar();

            this.chart.scrollbarX.series.push(this.lines.actionBuffer);
            let scrollContainer = am4core.create('scrollbar-' + this.GUID, am4core.Container);
            scrollContainer.width = am4core.percent(95);
            scrollContainer.align = 'center';
            this.chart.scrollbarX.parent = scrollContainer;
            this.chart.scrollbarX.thumb.width = 100;

            // set locales
            if (this.translateService.currentLang === 'ru'){
                this.chart.scrollbarX.language.locale = am4lang_ru_RU;
            }
        }

        // scrollbar
        this.chart.scrollbarY = new am4core.Scrollbar();
        this.chart.scrollbarY.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.endGrip.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.startGrip.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.thumb.background.fill = am4core.color("lightgrey");
        this.chart.scrollbarY.stroke = am4core.color("lightgrey");

        this.chart.legend.itemContainers.template.events.on("hit", (ev) =>{
            let lbl = this.chart.map.getKey(ev.target.dataItem.dataContext.dataFields.valueY);
        });

        let t1 = performance.now();
        console.log("Time: " + (t1 - t0) + " milliseconds.");
    };

    private addCursor = (): void => {
        //# cursor and legend
        this.chart.cursor = new am4charts.XYCursor();
        this.chart.cursor.behavior = "selectX";

        //# Show overal close values when cursor is not shown
        this.chart.cursor.events.on("hidden", (ev) =>{
            if (!this.freezeDataChange){
                this.updateStaticPopup();
            }
        });

        //# Set up cursor's events to update the label
        this.chart.cursor.events.on("cursorpositionchanged", (ev) =>{
            if (!this.freezeDataChange){
                this.updateStaticPopup(this.chartXAxix);
            }
        });

        this.chart.cursor.events.on("selectended", (ev) =>{
            // console.log(ev, 'selectended')
            if (ev.target.xRange){
                this.savedRange = ev.target.xRange;
            } else{
                this.savedRange = null;
                if (this.CTRLPressed) {
                    this.freezeDataChange = !this.freezeDataChange
                }
            }

            this.bufferAgg(this.savedRange);
            this.salesAgg(this.savedRange);


        });

        this.chart.cursor.events.on("hit", (ev) =>{
            // console.log(ev, 'hit')


        });
    }

    //# update zoom
    private updateZoom = (start: Date, end: Date): void =>{
        if (!this.isMainChart){
            this.chartXAxix.zoomToDates(start, end);
            this.bubbleChartXAxix.zoomToDates(start, end);
        }
    };

    //# generate aggregation for sales
    private salesAgg = (range?): void =>{
        let dates: ChartAggDatesModel = this.getRangeDates(range),
            data: ChartAggDataSales = this.getDataSalesAgg(dates, range);
        dates = this.checkRangeDates(dates, data.cnt);
        this.updateSalesAgg(dates.period, data);
    };

    //# generate aggregation for buffer
    private bufferAgg = (range?): void =>{
        this.agg = [];
        let dates: ChartAggDatesModel = this.getRangeDates(range),
            data: ChartAggDataBuffer = this.getDataBufferAgg(dates, range);
        dates = this.checkRangeDates(dates, data.cnt);
        this.updateBufferAgg(dates.period, data.avg, data.max, data.min);
    };

    //# set colors for legend (no use)
    private legendColors = (adapter: string, target, defColor: string = '#000000'): any =>{
        if (!target.dataItem){
            return defColor;
        }
        let settings = target.dataItem.dataContext.dummyData;
        return settings && settings.color !== undefined ? am4core.color(settings.color) : am4core.color(defColor);
    };

    //# get dates range after selection range on line chart
    private getRangeDates = (range?: any): ChartAggDatesModel =>{
        let from, to;
        if (range){
            let axis = this.chartXAxix;

            from = axis.positionToDate(axis.toAxisPosition(range.start));

            to = axis.positionToDate(axis.toAxisPosition(range.end));
            let endDateToday = moment(to).format(this.helper.ru_Date) === this.chartData.todayDate.format(this.helper.ru_Date);
            let endDateAfter = moment(to).startOf('day').isAfter(this.chartData.todayDate.startOf('day'));
            if (endDateToday || endDateAfter){
                let date = new Date(to);
                let days: number = endDateToday ? 1 : 2;

                date.setDate(to.getDate() - days);
                to = date;
            }
        } else{
            from = moment(this.chartData.startDate).toDate();
            let endDateToday = this.chartData.endDate.startOf('day').isSame(this.chartData.todayDate.startOf('day'));
            to = endDateToday ? moment(this.chartData.endDate.clone().subtract(1, "days")).toDate() : moment(this.chartData.endDate).toDate();
        }

        let period = from.toLocaleDateString("ru-ru") + " - " + to.toLocaleDateString("ru-ru");
        return new ChartAggDatesModel(period, from, to);
    };

    //# check dates range
    private checkRangeDates = (dates: ChartAggDatesModel, cnt: number): ChartAggDatesModel =>{
        if (cnt === 1){
            dates.period = dates.to.toLocaleDateString("ru-ru") + " - " + dates.to.toLocaleDateString("ru-ru");
        }
        return dates;
    };


    //# generate data for sales aggregation
    private getDataSalesAgg = (dates: ChartAggDatesModel, range?): ChartAggDataSales =>{
        let sumSales: number = 0, days: number = 0, avg: number = 0, min = 9999999, max = -9999999, cnt: number = 0,
            sumOther: number = 0, simDiscountSales: number = 0,
            dataset = this.lines.actionBuffer.dataItems.values;
        let from = this.helper.removeTime(dates.from),
            to = this.helper.removeTime(dates.to);
        const maxMin = (i: number): void =>{
            if (dataset[i].dataContext.qntOut1 > max) max = dataset[i].dataContext.qntOut1;
            if (dataset[i].dataContext.qntOut1 < min) min = dataset[i].dataContext.qntOut1;
        };

        const sales = (i: number): void => {
            if (dataset[i].dataContext.qntOut1 == null){
                dataset[i].dataContext.qntOut1 = 0;
            }

            sumSales += dataset[i].dataContext.qntOut1;
            sumOther += dataset[i].dataContext.qntOut2;
            simDiscountSales += dataset[i].dataContext.discountQnt;
        }

        for (let i = 0; i < dataset.length; i++){
            if (range){
                if (dataset[i].dateX >= from && dataset[i].dateX <= to){
                    if (dataset[i].dataContext.balance > 0 || dataset[i].dataContext.valueOut > 0){
                        sales(i);
                        maxMin(i);
                        days++;
                    }
                    cnt++;
                }
            } else {
                if (dataset[i].dataContext.balance > 0 || dataset[i].dataContext.valueOut > 0){
                    days++;
                    sales(i);
                    maxMin(i);
                }
                cnt++;
            }
        }


        avg = (sumSales / cnt);
        min = min === null || min === 9999999 ? 0 : min;
        max = max === null || max === -9999999 ? 0 : max;
        avg = isNaN(avg) ? 0 : avg;
        sumSales = isNaN(sumSales) || sumSales === null ? 0 : sumSales;
        sumOther = isNaN(sumOther) || sumOther === null ? 0 : sumOther;
        simDiscountSales = isNaN(simDiscountSales) || simDiscountSales === null ? 0 : simDiscountSales;

        return new ChartAggDataSales(sumSales, simDiscountSales, sumOther, avg, max, min, cnt, days, cnt - days);
    };

    //# generate data for buffer aggregation
    private getDataBufferAgg = (dates: ChartAggDatesModel, range?): ChartAggDataBuffer =>{
        let dataset = this.lines.actionBuffer.dataItems.values,
            sum = 0, avg = 0, min = 9999999, max = -9999999, cnt = 0;
        let from = this.helper.removeTime(dates.from),
            to = this.helper.removeTime(dates.to);
        const maxMin = (i: number): void =>{
            if (dataset[i].dataContext.actionBuffer > max) max = dataset[i].dataContext.actionBuffer;
            if (dataset[i].dataContext.actionBuffer < min) min = dataset[i].dataContext.actionBuffer;
        }

        for (let i = 0; i < dataset.length; i++){
            if (range){
                if (dataset[i].dateX >= from && dataset[i].dateX <= to){
                    cnt++;
                    sum += dataset[i].dataContext.actionBuffer;
                    maxMin(i);
                }
            } else{
                cnt++;
                sum += dataset[i].dataContext.actionBuffer;
                maxMin(i);
            }
        }

        avg = (sum / cnt);

        min = min === null || min === 9999999 ? 0 : min;
        max = max === null || max === -9999999 ? 0 : max;
        avg = isNaN(avg) ? 0 : avg;
        //sum = isNaN(sum) || sum === null ? 0 : sum;

        return new ChartAggDataBuffer(avg, min, max, cnt)
    };

    //# set data for sales aggregations
    private updateSalesAgg = (period: string, data: ChartAggDataSales): void =>{
        // this.aggPeriod = period;
        this.agg.push(new ChartAggModel('Sales', 'SUM', data.sumSales.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('MainChart_DiscountQnt', 'SUM', data.sumDiscountSales.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('MainChart_QntOut2', 'SUM', data.sumOther.toFixed(4).toString()));
        this.agg.push(new ChartAggModel('Sale', 'AVG', data.avg.toFixed(4)));
        this.agg.push(new ChartAggModel('Sale', 'MIN', data.min.toString()));
        this.agg.push(new ChartAggModel('Sale', 'MAX', data.max.toString()));
        this.agg.push(new ChartAggModel('Chart_DaysSale', '', data.withSales.toString()));
        this.agg.push(new ChartAggModel('Chart_DaysWithoutSale', '', data.withoutSales.toString()));
    };

    //# set data for buffer aggregations
    private updateBufferAgg = (period: string, avg: number, max: number, min: number): void =>{
        this.aggPeriod = period;
        this.agg.push(new ChartAggModel('Buffer', 'AVG', avg.toFixed(4)));
        this.agg.push(new ChartAggModel('Buffer', 'MIN', min.toString()));
        this.agg.push(new ChartAggModel('Buffer', 'MAX', max.toString()));
    };

    //# add line for line chart
    private addLineWithOptions = (name: string, color: string, isFilled: boolean, showBullet: boolean, defaultColumn: boolean, defaultVisibility: boolean, displayName: string, idx: number): void =>{
        this.lines[name] = this.chart.series.push(new am4charts.LineSeries());
        this.lines[name].showOnInit = false;
        this.lines[name].dataFields.buffer = 'bufferGBT';
        this.lines[name].dataFields.actionBufferABT = 'bufferABT';
        this.lines[name].dataFields.valueY = name;
        this.lines[name].dataFields.dateX = "date";
        this.lines[name].strokeWidth = 2;
        this.lines[name].name = displayName;
        this.lines[name].stroke = am4core.color(color);
        this.lines[name].fill = am4core.color(color);
        this.lines[name].minBulletDistance = 15;
        this.lines[name].hiddenInLegend = defaultColumn;
        this.lines[name].defaultState.transitionDuration = 0;
        this.lines[name].hiddenState.transitionDuration = 0;
        this.lines[name].cursorTooltipEnabled = false;

        if (name === 'replenishmentTime'){
            this.lines[name].yAxis = this.chartYAxix2;
            this.chartYAxix2.disabled = !defaultVisibility;
        }

        this.lines[name].dummyData = {
            color: color,
            name: name
        };

        if (isFilled){
            this.lines[name].strokeWidth = 0;
            this.lines[name].fillOpacity = 1;
            this.lines[name].fill = am4core.color(color);
        }

        if (showBullet){
            this.lines[name + "bullet"] = this.lines[name].bullets.push(new am4charts.CircleBullet());
            this.lines[name + "bullet"].circle.strokeWidth = 0;
            this.lines[name + "bullet"].circle.radius = 6;
            this.lines[name + "bullet"].circle.fill = am4core.color('rgba(0,0,0,0)');
            if (name === 'actionBuffer'){
                this.lines[name + "bullet"].fill = am4core.color("#7FC07F");
                this.lines[name + "bullet"].tooltipText = `${displayName}: {actionBufferABT}`;
            } else if (name === 'bufferG'){
                this.lines[name + "bullet"].tooltipText = `${displayName}: {buffer}`;
            } else if (name === 'actionSafetyBuffer'){
                this.lines[name + "bullet"].fill = am4core.color("#B22222");
                this.lines[name + "bullet"].tooltipText = `${displayName}: {valueY}`;
            } else {
                this.lines[name + "bullet"].tooltipText = `${displayName}: {valueY}`;
            }

            let segment = this.lines[name].segments.template;
            segment.interactionsEnabled = true;

            let hs = segment.states.create("hover");
            hs.properties.strokeWidth = 3;

            this.lines[name + "bullet"].events.on("hit", (event) =>{
                // this.savePDF();
            })

            //this.lines[name + "bullet"].events.on("click", (event) => {
            //  this.lines[name + "bullet"].tooltipText = "This is something else";
            //});
            let bullethover = this.lines[name + "bullet"].states.create("hover");
            bullethover.properties.scale = 1.3;

            this.lines[name + 'innerCircle'] = this.lines[name + "bullet"].createChild(am4core.Circle);
            this.lines[name + 'innerCircle'].verticalCenter = "middle";
            this.lines[name + 'innerCircle'].horizontalCenter = "middle";

            this.lines[name + 'innerCircle'].radius = 2.5;
            let bullerColor: string = '';

            switch (name){
                case 'actionBuffer': bullerColor = '#7FC07F'; break;
                case 'actionSafetyBuffer': bullerColor = '#B22222'; break;
                default: bullerColor = color; break;
            }

            this.lines[name + 'innerCircle'].fill = am4core.color(bullerColor);

            this.lines[name + 'innerCircle'].strokeWidth = 0;

            let innerCircleHover = this.lines[name + 'innerCircle'].states.create("hover");
            innerCircleHover.properties.scale = 1.3;

            // set black border for buffer line when no data
            if (name === 'actionBuffer'){
                this.lines[name + "innerCircle"].stroke = am4core.color('#000000');
                this.lines[name].dataFields.value = "noDataBool";

                this.lines[name].heatRules.push({
                    target: this.lines[name + "innerCircle"],
                    minValue: 0,
                    maxValue: 1,
                    min: 0,
                    max: 1,
                    property: "strokeWidth",
                    dataField: "value"
                });

                this.lines[name].heatRules.push({
                    target: this.lines[name + "innerCircle"],
                    minValue: 0,
                    maxValue: 1,
                    min: 2.5,
                    max: 3,
                    property: "radius",
                    dataField: "value"
                });
            }

            // this.lines[name + "event"] = this.lines[name + "bullet"].events.on("rollOverGraphItem", function (ev) {
            // }, this);
        }
        if (!defaultVisibility){
            this.lines[name].visible = false;
            this.lines[name].hidden = true;
        }

        this.lines[name].events.on("shown", () =>{
            this.updateStaticPopup();
        });

        this.lines[name].events.on("hidden", () =>{
            this.updateStaticPopup();
        });
    };

    //# send message to service for update line visibility for line chart in main and compare chart
    public toggleShowLines = (lineName: string): void =>{
        this.dataExchange.setToggleLinesVisibility({type: this.type, sharedGUID: this.sharedGUID, lineName: lineName});
    };

    //# get message from service for update line visibility for line chart in main and compare chart
    private updateLineVisibility = (data: { type: string, sharedGUID: string, lineName: string }): void =>{
        if (data && data.type === this.type && data.sharedGUID === this.sharedGUID){
            let lineName = data.lineName,
                line = this.info.find(item => item.name === lineName);

            if (!line || line.hideLineInLegend && line.name !== 'targetStockLevel'){
                return;
            }

            line.enabled ? this.lines[lineName].hide() : this.lines[lineName].show();
            line.enabled = !line.enabled;

            if (lineName === 'replenishmentTime'){
                this.chartYAxix2.disabled = !line.enabled;
                this.chartYAxix2.start = 0;
                this.chartYAxix2.end = 1;
                this.rightAxis = line.enabled;
            }
        }
    }

    //# disable current legend in info
    private disableLegend = (lineName: string): void =>{
        let line = this.info.find(item => item.name === lineName);

        if (!line){
            return;
        }

        line.enabled = false;
    };


    // Updates values for info, line chart
    private updateStaticPopup = (dateAxis: any = null): void =>{
        // console.trace('updateStaticPopup')
        let date: string = '';
        this.chart.series.each((series) =>{
            date = date ? date : this.getDate(series, dateAxis);
            let line: ChartLineModel = this.info.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }
            // if(!series.hidden && series.visible){
            if (series.visible){
                let dataItem: any = this.getDataItem(series, dateAxis);

                if (!dataItem){
                    return;
                }

                if (dataItem["valueY"] === undefined || dataItem["valueY"] === null){
                    line.value = this.translates.NoData;
                } else{
                    switch (line.name){
                        case 'actionBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.bufferG);
                            break;
                        case 'bufferG':
                            // line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer - dataItem.dataContext.actionSafetyBuffer);
                            line.value = this.chart.numberFormatter.format(dataItem.dataContext.actionBuffer - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferY':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferR':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'safetyBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'actionSafetyBuffer':
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer);
                            break;
                        default:
                            line.value = this.chart.numberFormatter.format(dataItem["valueY"]);
                    }
                }
                //this.info.push(label);
            } else{
                line.value = this.translates.OffShort;
            }
        });

        this.updateStaticPopupBubble(date)
    };

    // Updates values for info, bubble chart
    private updateStaticPopupBubble = (date: string): void =>{
        if (!this.bubbleChart){
            return;
        }

        this.bubbleChart.series.each((series) =>{
            let line: ChartLineModel = this.infoBubble.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }

            let cDate = moment(date).format('YYYY-MM-DD') + 'T00:00:00Z';

            if (series.visible){
                line.value = this.bubbleChartData.find(item => item[series.dummyData.name] && cDate === item.date) ? '1' : '';
            }
        })
    };

    //# get date item obj from date axis and set date for info header
    private getDate = (series: any, dateAxis: any): string =>{
        let dataItem: any = this.getDataItem(series, dateAxis);

        if (!dataItem || dataItem && !dataItem['dateX']){
            return ''
        }

        if (this.translateService.currentLang === 'ru'){
            this.stpDate = moment(dataItem['dateX']).format('DD.MM.YYYY')
        } else{
            this.stpDate = moment(dataItem['dateX']).format('YYYY.MM.DD')
        }
        return dataItem['dateX'];
    };

    //# get date item obj from date axis
    private getDataItem = (series: any, dateAxis: any): any =>{
        let dataItem: any = null;

        if (dateAxis){
            dataItem = dateAxis.getSeriesDataItem(
                series,
                dateAxis.toAxisPosition(this.chart.cursor.xPosition),
                true
            );
        } else{
            dataItem = series.dataItems.last;
        }

        return dataItem
    }

    public setSelected = (view: Slick.Column<any>[], column: Slick.Column<any>, qntVariableName: string): void =>{
        column.selected = !column.selected;
        this[qntVariableName] = view.filter(item => item.selected).length;
    };

    private showTargetLevel = (show: boolean): void =>{
        show ? this.lines.targetStockLevel.show() : this.lines.targetStockLevel.hide();
    };

    public emit = (emit: boolean): void =>{
        if (emit){
            // this.pushData.emit({columnsView: this.columnsView, columnsParameters: this.columnsParameters, columnsHidden: this.columnsHidden});
        }
    }

    public toggleLegendShow = (): void =>{
        this.legendVisible = !this.legendVisible;
    }

    private updateLgHeight = (): void =>{
        // console.log(this.legenddiv.nativeElement.offsetHeight, 'this.legenddiv.nativeElement.offsetHeight')
        // this.lgHeight = this.legenddiv.nativeElement.offsetHeight;
    }

    //# generate bubble chart
    private generateBubbleChart2 = () =>{
        this.bubbleChart = am4core.create('bubble-' + this.GUID, am4charts.XYChart);

        this.chart.resizable = true;

        if (this.translateService.currentLang === 'ru'){
            this.bubbleChart.language.locale = am4lang_ru_RU;
        }
        //console.log(this.bubbleChartData, 'this.bubbleChartData;');
        this.bubbleChart.data = this.bubbleChartData;
        //this.bubbleChart.responsive.enabled = true;
        this.bubbleChart.zoomOutButton.disabled = true;

        // Create axes
        this.bubbleChartXAxix = this.bubbleChart.xAxes.push(new am4charts.DateAxis());
        this.bubbleChartXAxix.dataFields.valyeY = name;
        // this.bubbleChartXAxix.dataFields.category = "category";
        // this.bubbleChartXAxix.renderer.grid.template.location = 0;
        this.bubbleChartXAxix.renderer.grid.template.strokeOpacity = 0;

        this.bubbleChartXAxix.renderer.axisFills.interactionsEnabled = true;

        this.bubbleChartYAxix = this.bubbleChart.yAxes.push(new am4charts.ValueAxis());
        this.bubbleChartYAxix.renderer.grid.template.strokeOpacity = 0;
        this.bubbleChartYAxix.hidden = true;
        this.bubbleChartYAxix.min = 0;
        //this.bubbleChartYAxix.max = this.bubbleChartLines.length + 2;
        this.bubbleChartYAxix.tooltip.disabled = true;
        // this.bubbleChartYAxix.renderer.labels.template.fill = am4core.color("rgba(0,0,0,0)");
        // this.bubbleChartYAxix.renderer.grid.template.stroke = am4core.color("rgba(0,0,0,0)");
        this.bubbleChartYAxix.renderer.axisFills.interactionsEnabled = true;

        this.setDatesDisplayProps(this.bubbleChart, this.bubbleChartXAxix);


        this.bubbleChartLines.forEach((item, i) =>{
            this.addLineBubbleChart(item.name, item.color, item.areaFilledOnLine, item.showBulletOnLine, item.hideLineInLegend, item.showLineByDefault, item.lineName, i);
        });

        this.bubbleChart.cursor = new am4charts.XYCursor();
        this.bubbleChart.cursor.lineY.disabled = true;
        this.bubbleChart.legend = new am4charts.Legend();
        this.bubbleChart.legend.itemContainers.template.togglable = false;


        const resizeLegend = (ev): void =>{
            document.getElementById('bubble-legend-' + this.GUID).style.height = this.bubbleChart.legend.contentHeight + "px";
            //this.lgHeight = this.legenddiv.nativeElement.offsetHeight;
            //console.log(this.chart.legend.contentHeight, 'this.chart.legend.contentHeight')
        };

        let legendContainer = am4core.create('bubble-legend-' + this.GUID, am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        //
        this.bubbleChart.legend.parent = legendContainer;

        // this.bubbleChart.focusFilter.stroke = am4core.color("#0f0");
        // this.bubbleChart.focusFilter.strokeWidth = 5;

        // this.chart.events.on("datavalidated", resizeLegend);
        // this.chart.events.on("shown", resizeLegend);

        this.bubbleChart.events.on("appeared", resizeLegend);
        // this.chart.events.on("maxsizechanged", resizeLegend);

        this.bubbleChart.events.on("sizechanged", resizeLegend);


        this.bubbleChart.legend.useDefaultMarker = true;

        let marker = this.bubbleChart.legend.markers.template.children.getIndex(0);
        marker.adapter.add("fill", this.legendColors);


        this.bubbleChart.events.on("ready", (ev) =>{
            this.bubbleChartReady = true;
            this.loading.emit(false);
        });

        this.bubbleChart.events.on("validated", (ev) =>{
            if (this.bubbleChartReady){
                this.loading.emit(false);
            }
        });


        // this.bubbleChart.scrollbarX = this.chart.scrollbarX;
        // this.chart.scrollbarX = this.bubbleChart.scrollbarX;

    }

    //# test no use
    private generateBubbleChart_test = () =>{
        // am4core.useTheme(am4themes_animated);
        // this.bubbleChart = am4core.create( "bubble-chartdiv", am4charts.XYChart );
        // this.bubbleChart.hiddenState.properties.opacity = 0;
        // this.bubbleChart.maskBullets = false;
        // this.chart.language.locale = am4lang_ru_RU;
        //
        // let xAxis = this.bubbleChart.xAxes.push(new am4charts.DateAxis());
        // let yAxis = this.bubbleChart.yAxes.push( new am4charts.CategoryAxis());
        // yAxis.dataFields.category = "data";

        this.bubbleChart = am4core.create("bubble-chartdiv", am4charts.XYChart);

// Add data
        let data = [{
            "date": "2015-01-01",
            "ay": 12,
            "by": 2.2,
            "aValue": 5,
            "bValue": 10
        }, {
            "date": "2015-01-02",
            "ay": 12,
            "by": 4.9,
            "aValue": 10,
            "bValue": 3
        }, {
            "date": "2015-01-03",
            "ay": 12,
            "by": 5.1,
            "aValue": 15,
            "bValue": 4
        }]

        this.bubbleChart.data = data;


// Create axes
        let xAxis = this.bubbleChart.xAxes.push(new am4charts.DateAxis());
        xAxis.dataFields.category = "category";
        xAxis.renderer.grid.template.location = 0;
//xAxis.renderer.minGridDistance = 30;

        let yAxis = this.bubbleChart.yAxes.push(new am4charts.ValueAxis());

// Create series
        let series1 = this.bubbleChart.series.push(new am4charts.LineSeries());
        series1.dataFields.valueY = "ay";
        series1.dataFields.dateX = "date";
        series1.dataFields.value = "aValue";
        series1.strokeOpacity = 0;
        series1.cursorTooltipEnabled = false;
        series1.stroke = am4core.color("blue");

        let bullet1 = series1.bullets.push(new am4charts.CircleBullet());
        bullet1.tooltipText = "x:{valueX} y:{valueY}";
        series1.heatRules.push({
            target: bullet1.circle,
            min: 5,
            max: 25,
            property: "radius"
        });

        bullet1.circle.fill = am4core.color("red");
        bullet1.circle.strokeWidth = 3;


        let series2 = this.bubbleChart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueY = "by";
        series2.dataFields.dateX = "date";
        series2.dataFields.value = "bValue";
        series2.strokeOpacity = 0;
        series2.cursorTooltipEnabled = false;

        let bullet2 = series2.bullets.push(new am4charts.CircleBullet());
        bullet2.tooltipText = "x:{valueX} y:{valueY} value:{value}";
        // bullet2.circle.fill = am4core.color("green");
        bullet2.circle.radius = 50;
        bullet2.circle.strokeWidth = 10;
        series2.fill = am4core.color("green");
        let gradient = new am4core.RadialGradient();
        gradient.addColor(am4core.color("blue"));
        // gradient.addColor(am4core.color("rgba(0,0,0,0)"));
        gradient.addColor(am4core.color("green"));
        gradient.cx = am4core.percent(50);
        gradient.cy = am4core.percent(100);
        // gradient.fx = am4core.percent(50);
        // gradient.fy = am4core.percent(50);
        // bullet2.stroke = gradient;
        bullet2.stroke = am4core.color("red");


        // bullet2.circle.fill = gradient;

        let fillModifier = new am4core.LinearGradientModifier();
        // fillModifier.opacities = [1, 0];
        // bullet2.template.fillModifier = fillModifier;

        // columnSeries.columns.template.fillModifier = fillModifier;


        bullet2.strokeOpacity = 0;

        bullet2.hiddenState.properties.scale = 0.01;
        bullet2.hiddenState.properties.opacity = 1;

        let hoverState = bullet2.states.create("hover");
        // hoverState.properties.strokeOpacity = 1;
        // console.log(hoverState.properties);
        // hoverState.properties.circle = {};
        // hoverState.properties.radius = 70;

        let shadow = bullet2.filters.push(new am4core.DropShadowFilter);
        // shadow.dx = 0;
        // shadow.dy = 0;
        // shadow.color = am4core.color("green");
        // shadow.opacity = 1;
        // shadow.height = 300;
        // shadow.width = 300;
        // shadow.blur = 5;
        //
        // bullet2.filters.removeIndex(0);
        //
        // bullet2.filters.push(shadow);
        shadow.opacity = 0;

        let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
        hoverShadow.dx = 0;
        hoverShadow.dy = 0;
        hoverShadow.color = am4core.color("green");
        hoverShadow.opacity = 1;
        hoverShadow.height = 300;
        hoverShadow.width = 300;
        hoverShadow.blur = 5;

        // hoverState.properties.fill = gradient;
        // series2.heatRules.push({
        //     target: bullet2.circle,
        //     min: 5,
        //     max: 40,
        //     property: "radius"
        // });

        let rectangle2 = bullet2.createChild(am4core.Circle);
        rectangle2.verticalCenter = "middle";
        rectangle2.horizontalCenter = "middle";

        rectangle2.radius = 30;
        rectangle2.fill = am4core.color("blue");

        // rectangle2.stroke = am4core.color("#fff");
        // rectangle2.strokeWidth = 5;
        rectangle2.strokeOpacity = 1;
        rectangle2.nonScalingStroke = true;

        let hoverState2 = rectangle2.states.create("hover");
        // hoverState.properties.strokeOpacity = 1;

        hoverState2.properties.radius = 50;
        // hoverState2.properties.fill = gradient;

        let rectangle3 = bullet2.createChild(am4core.Circle);
        rectangle3.verticalCenter = "middle";
        rectangle3.horizontalCenter = "middle";

        rectangle3.radius = 15;
        rectangle3.fill = am4core.color("red");

        rectangle3.stroke = am4core.color("#fff");
        rectangle3.strokeWidth = 5;
        rectangle3.strokeOpacity = 1;
        // rectangle3.nonScalingStroke = true;

        let fillModifier2 = new am4core.LinearGradientModifier();
        fillModifier2.opacities = [1, 1, 0];
        // fillModifier.offsets = [0, 0.8, 1];
        // series2.columns.template.fillModifier = fillModifier;

        /*var rectangle2 = bullet2.createChild(am4core.Rectangle);
        rectangle2.verticalCenter = "middle";
        rectangle2.horizontalCenter = "middle";
        rectangle2.width = 10;
        rectangle2.height = 10;
        rectangle2.rotation = 45;
        rectangle2.stroke = am4core.color("#fff");
        rectangle2.strokeWidth = 1;
        rectangle2.nonScalingStroke = true;
        series2.heatRules.push({
            target: rectangle2,
            min: 1,
            max: 6,
            property: "scale"
        });*/

// Add scrollbars
//         chart.scrollbarX = new am4core.Scrollbar();
//         chart.scrollbarY = new am4core.Scrollbar();

// Add cursor
//         chart.cursor = new am4charts.XYCursor();
//         chart.cursor.behavior = "zoomXY";
    };

    //# generate data for bubble chart
    private generateBubbleChartData = (): void =>{
        this.bubbleChartData = this.chartData.rows.map(item =>{
            let row: any = {};
            row.date = item.date;
            this.bubbleChartLines.forEach((inItem, i) =>{
                row[inItem.name] = item[inItem.name] ? ++i : null;
            });
            return row;
        });

        // console.log(this.bubbleChartData, 'this.bubbleChartData');

    };

    //# add lines for bubble chart
    private addLineBubbleChart = (name: string, color: string, isFilled: boolean, showBullet: boolean, defaultColumn: boolean, defaultVisibility: boolean, displayName: string, idx: number): void =>{

        this.bubbleLines[name] = this.bubbleChart.series.push(new am4charts.LineSeries());

        let line = false;

        // console.log(this.bubbleLines[name], 'this.bubbleLines', name)

        this.bubbleLines[name].showOnInit = false;
        this.bubbleLines[name].dataFields.valueY = name;
        this.bubbleLines[name].dataFields.dateX = "date";
        this.bubbleLines[name].strokeOpacity = 0;
        this.bubbleLines[name].cursorTooltipEnabled = false;
        this.bubbleLines[name].fill = am4core.color(color);
        if (!line){
            this.bubbleLines[name].interpolationDuration = 0;
            this.bubbleLines[name].defaultState.transitionDuration = 0;
            this.bubbleLines[name].hiddenState.transitionDuration = 0;
        }

        // this.bubbleLines[name].showOnInit = false;

        this.bubbleLines[name].name = displayName;
        this.bubbleLines[name].stroke = am4core.color(color);
        this.bubbleLines[name].hiddenInLegend = defaultColumn;


        if (!line){
            this.bubbleLines[name].bulletData = this.bubbleLines[name].bullets.push(new am4charts.CircleBullet());
            this.bubbleLines[name].bulletData.hiddenState.properties.scale = 0.01;
            this.bubbleLines[name].bulletData.hiddenState.properties.opacity = 0.7;
            this.bubbleLines[name].bulletData.tooltipText = `${displayName}: {dateX}`;
            this.bubbleLines[name].bulletData.circle.radius = 3;
        }

        if (line){
            this.bubbleLines[name].showOnInit = true;
            this.bubbleLines[name].strokeOpacity = 1;

            let segment = this.bubbleLines[name].segments.template;
            segment.interactionsEnabled = true;

            let hs = segment.states.create("hover");
            hs.properties.strokeWidth = 5;
            this.bubbleLines[name].segments.template.strokeWidth = 1;
        }



        let shadow = false;

        this.bubbleLines[name].dummyData = {color, displayName, name, shadow};

        this.bubbleLines[name].bulletHover = this.bubbleLines[name].bulletData.states.create("hover");
        this.bubbleLines[name].bulletHover.properties.scale = 1.5;




        this.bubbleLines[name].bulletShadow = this.bubbleLines[name].bulletData.filters.push(new am4core.DropShadowFilter);
        this.bubbleLines[name].bulletShadow.opacity = 0;

        this.bubbleLines[name].bulletHoverShadow = this.bubbleLines[name].bulletHover.filters.push(new am4core.DropShadowFilter);
        this.bubbleLines[name].bulletHoverShadow.dx = 0;
        this.bubbleLines[name].bulletHoverShadow.dy = 0;
        this.bubbleLines[name].bulletHoverShadow.color = am4core.color(color);
        this.bubbleLines[name].bulletHoverShadow.opacity = 1;
        this.bubbleLines[name].bulletHoverShadow.height = 300;
        this.bubbleLines[name].bulletHoverShadow.width = 300;
        this.bubbleLines[name].bulletHoverShadow.blur = 2;


        this.bubbleLines[name].innerCircle = this.bubbleLines[name].bulletData.createChild(am4core.Circle);
        this.bubbleLines[name].innerCircle.verticalCenter = "middle";
        this.bubbleLines[name].innerCircle.horizontalCenter = "middle";

        this.bubbleLines[name].innerCircle.radius = 1;
        this.bubbleLines[name].innerCircle.fill = am4core.color("#fff");

        this.bubbleLines[name].innerCircle.stroke = am4core.color("#fff");
        this.bubbleLines[name].innerCircle.strokeWidth = 0;
        this.bubbleLines[name].innerCircle.strokeOpacity = 1;

        //this.bubbleLines[name].columns.template.fillOpacity = 0.7;


        // hs.circle.radius = 5;

    };

    public hoverLine2 = (series: any, enter: boolean): void =>{
        // series.isHover = enter;
        series.bulletData.isHover = enter;
        // console.log(series, 'series');
        // console.log(series.bulletData, 'bulletData');
        // console.log(series.bulletHover, 'bulletHover');
        // console.log(series.bulletShadow, 'bulletShadow');
        // console.log(series.bulletHoverShadow, 'bulletHoverShadow');


        // series.segments.each((segment) =>{
            // console.log(segment, 'series.segments.each ' + event);
            // segment.isHover = enter;
        // });
    }

    public toggleLegendBubbleShow = (): void =>{
        this.legendBubbleVisible = !this.legendBubbleVisible;
    };

    //# toggle show bubble chart on main and compare chart
    public toggleBubbleShow = (): void =>{
        // console.log('toggleBubbleShow')
        this.dataExchange.setToggleBubbleChart({
            type: this.type,
            sharedGUID: this.sharedGUID,
            show: !this.bubbleVisible
        });
        // this.bubbleVisible = !this.bubbleVisible;
    };

    //# research no use
    private toggleShadowAllBubbles = (name: string): void =>{
        if (!this.bubbleLines[name].dummyData.shadow){
            // console.log(this.bubbleLines[name].dummyData, 'toggleShadowAllBubbles this.bubbleLines[name].dummyData');

            let series = this.bubbleChart.series.push(new am4charts.LineSeries());
            let bullet = series.bullets.push(new am4charts.CircleBullet());

            let square = bullet.createChild(am4core.Rectangle);

            square.invalidate();


            this.bubbleLines[name].bulletData.filters.clear();
            // this.bubbleLines[name].bulletShadow = this.bubbleLines[name].bulletData.filters.push(new am4core.DropShadowFilter);
            // this.bubbleLines[name].bulletShadow.opacity = 1;
            // console.log(this.bubbleLines[name], 'toggleShadowAllBubbles this.bubbleLines[name]');
            // this.bubbleLines[name].bulletShadow.dx = 0;
            // this.bubbleLines[name].bulletShadow.dy = 0;
            // this.bubbleLines[name].bulletShadow.color = am4core.color(this.bubbleLines[name].dummyData.color);
            //
            // this.bubbleLines[name].bulletShadow.height = 300;
            // this.bubbleLines[name].bulletShadow.width = 300;
            // this.bubbleLines[name].bulletShadow.blur = 2;
            // ;

        } else{
            // this.bubbleLines[name].bulletShadow.opacity = 0;
        }

        this.bubbleLines[name].dummyData.shadow = !this.bubbleLines[name].dummyData.shadow;
    };

    //# update data for line and bubble chart
    private updateChartData = (dataModel: ChartSetDataModel): void =>{
        //console.trace(dataModel, 'updateChartData chart')
        //console.log(this.GUID, 'updateChartData chart')
        if (!dataModel || dataModel.GUID !== this.GUID){
            return;
        }
        this.chartData = dataModel.data;

        //let ax = this.chart.yAxes.push(new am4charts.ValueAxis());

        //ax.selection.hide

        //this.chartYAxix.selection.hide();
        //console.log(this.chartYAxix, 'this.chartYAxix')
        this.chart.cursor.selection.hide();
        this.chart.cursor.dispose();

        this.addCursor();

        this.itemId = dataModel.data.itemInfo.itemId;
        // this.setChartProps();
        // this.updateLegends();
        this.chart.data = this.chartData.rows;
        // this.chartYAxix.keepSelection = true;
        this.chartYAxix.start = 0;
        this.chartYAxix.end = 1;
        this.info.forEach(line => {
            if (line.name === 'replenishmentTime' && line.enabled){
                this.updateLineVisibility({type: this.type, sharedGUID: this.sharedGUID, lineName: 'replenishmentTime'});
                this.helper.wait(() => this.updateLineVisibility({type: this.type, sharedGUID: this.sharedGUID, lineName: 'replenishmentTime'}), 10)
            }
        })
        // this.chartYAxix2.start = 0;
        // this.chartYAxix2.end = 1;

        //this.chart.goHome();
        this.generateBubbleChartData();
        this.bubbleChart.data = this.bubbleChartData;
        this.updateCWHItemId();
    };

    //#
    public showWrhListFunc = (): void =>{
        if (!this.showWrhList){
            this.showWrhList = true;
        }
        this.showCustomLists = false;
    };

    //# add compare chart
    public addCompareChart = (itemId: number): void =>{
        if (!this.isMainChart){
            return;
        }

        let newChart = new AddChartModel(itemId, this.helper.generateGUID(), this.sharedGUID, this.type);
        newChart = this.setToNewChartDates(newChart);
        this.dataExchange.setAddChart(newChart);
        this.showCustomLists = false;
        this.hideCompareBtn = true;
    };

    //# add dates from period selector to compare chart
    private setToNewChartDates = (newChart: AddChartModel): AddChartModel =>{
        newChart.startDate = this.chartPeriodSelector.startDate;
        newChart.endDate = this.chartPeriodSelector.endDate;
        return newChart;
    }

    //# show custom chart add form
    public showCustomList = (): void =>{
        if (this.showCustomLists){
            this.customListsPopper.destroy();
            this.customListsPopper = null;
            this.showCustomLists = false;
        } else{
            this.showCustomLists = true;
            this.customListsPopperCreate = true;
        }
    };

    //# set date display format for chart
    private setDatesDisplayProps = (chart: any, axisY: any): void =>{
        chart.dateFormatter.dateFormat = "dd-MM-yyyy";
        axisY.dateFormats.setKey("day", "dd.MM.yyyy");
        axisY.periodChangeDateFormats.setKey("day", "dd.MM.yyyy");
        axisY.dateFormats.setKey("month", "MMM yyyy");
        axisY.periodChangeDateFormats.setKey("month", "MMM yyyy");
        axisY.dateFormats.setKey("week", "dd.MM.yyyy");
        axisY.periodChangeDateFormats.setKey("week", "dd.MM.yyyy");
    }

    //# add popper to compare custom chart form
    public popperAdd = (): void =>{
        if (!this.customListBtn || !this.customListsWrp){
            return;
        }

        this.customListsPopper = new Popper(this.customListBtn.nativeElement, this.customListsWrp.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrapper.nativeElement,
                },
            },
        });
    };

    //# add popper for chart compare buttons wrapper
    public comparePopperAdd = (): void =>{

        if (!this.isMainChart){
            return;
        }
        this.compareButtonsPopper = new Popper(this.showCompBtn.nativeElement, this.btnWrpCompare.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrapper.nativeElement,
                },
            },
        });
    };

    //# updates popper add compare chart form
    public popperUpd = (): void =>{
        this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        this.customListsPopper.update();
    };

    //# close compare chart
    public close = (): void =>{
        if (this.isMainChart){
            return;
        }

        this.closeOut.emit(true);
    }

    //# toggle Info Show for main chart and compare chart
    public toggleInfoShow = (): void =>{
        this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: !this.showInfo});
        this.compareButtonsPopperUpdate = true;
        this.customListsPopperCreate = true;
        //this.showInfo = !this.showInfo;
    }

    //# sync lines between main and compare chart
    private sendLinesPropsToCompareChart = (data: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }): void =>{
        if (this.isMainChart && data.sharedGUID === this.sharedGUID){
            this.dataExchange.setCompareChartReady({
                command: 'update',
                type: this.type,
                sharedGUID: this.sharedGUID,
                lines: this.info
            })
        }
    }

    //# set lines from main to compare chart
    private setLinesProps = (data: { command: string, type: string, sharedGUID: string, lines: ChartLineModel[] }): void =>{
        if (!this.isMainChart && data.sharedGUID === this.sharedGUID){
            this.info.forEach(item =>{
                data.lines.forEach(inItem =>{
                    if (item.name === inItem.name){
                        item.enabled = inItem.enabled;
                    }
                })
            })

            this.updateChartLines();
        }
    }

    //# research
    public hoverLine = (series: any, enter: boolean): void =>{
        // console.log(event, 'hoverLine');
        series.segments.each((segment) =>{
            // console.log(segment, 'series.segments.each ' + event);
            segment.isHover = enter;
        });
    }

    public savePDF = (): void =>{

        Promise.all([
            this.chart.exporting.pdfmake,
            this.chart.exporting.getImage("png"),
            // chart2.exporting.getImage("png"),
            // chart3.exporting.getImage("png"),
            // chart4.exporting.getImage("png")
        ]).then((res) =>{

            let pdfMake = res[0];

            // pdfmake is ready
            // Create document template
            let doc: any = {
                pageSize: "A4",
                pageOrientation: "landscape",
                pageMargins: [30, 30, 30, 30],
                content: []
            };

            doc.content.push({
                text: "In accumsan velit in orci tempor",
                fontSize: 20,
                bold: true,
                margin: [0, 20, 0, 15]
            });

            doc.content.push({
                text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sem quam, sodales ac volutpat sed, vestibulum id quam. Sed quis arcu non elit fringilla mattis. Sed auctor mi sed efficitur vehicula. Sed bibendum odio urna, quis lobortis dui luctus ac. Duis eu lacus sodales arcu tincidunt ultrices viverra a risus. Vivamus justo massa, malesuada quis pellentesque ut, placerat in massa. Nunc bibendum diam justo, in consequat ipsum fringilla ac. Praesent porta nibh ac arcu viverra, at scelerisque neque venenatis. Donec aliquam lorem non ultrices ultrices. Aliquam efficitur eros quis tortor condimentum, id pellentesque metus iaculis. Aenean at consequat neque, a posuere lectus. In eu libero magna. Pellentesque molestie tellus nec nisi molestie, eu dignissim lacus tristique. Sed tellus nulla, suscipit a velit non, mattis dictum metus. Curabitur mi mi, convallis nec libero quis, venenatis vestibulum ante.",
                fontSize: 15,
                margin: [0, 0, 0, 15]
            });

            doc.content.push({
                text: "Aliquam lacinia justo",
                fontSize: 20,
                bold: true,
                margin: [0, 20, 0, 15]
            });

            doc.content.push({
                image: res[1],
                width: 530
            });

            doc.content.push({
                text: "Phasellus suscipit in diam a interdum",
                fontSize: 20,
                bold: true,
                margin: [0, 20, 0, 15]
            });

            let table = this.lineTable();

            doc.content.push({
                table: {
                    headerRows: 1,
                    widths: table[0].tWidth,
                    body: table[0].tBody
                }
            });

            doc.content.push({
                table: {
                    headerRows: 1,
                    widths: table[1].tWidth,
                    body: table[1].tBody
                }
            });

            /*doc.content.push({
                table: {
                    headerRows: 1,
                    widths: [ "*", "*", "*", "*" ],
                    body: [
                        [
                            { text: "USA", bold: true },
                            { text: "Japan", bold: true },
                            { text: "France", bold: true },
                            { text: "Mexico", bold: true }
                        ],
                        [ "2500", "2500", "2200", "1200" ],
                        [ "800", "1200", "990", "708" ],
                        [ "2100", "2150", "900", "1260" ],
                    ]
                }
            });*/

            doc.content.push({
                text: "Duis sed efficitur mauris",
                fontSize: 20,
                bold: true,
                margin: [0, 20, 0, 15]
            });

            doc.content.push({
                columns: [{
                    image: res[1],
                    width: 250
                }, {
                    image: res[1],
                    width: 250
                }],
                columnGap: 30
            });

            doc.content.push({
                text: "Aliquam semper lacinia",
                fontSize: 20,
                bold: true,
                margin: [0, 20, 0, 15]
            });

            doc.content.push({
                columns: [{
                    image: res[1],
                    width: 150
                }, {
                    stack: [{
                        text: "Maecenas congue leo vel tortor faucibus, non semper odio viverra. In ac libero rutrum libero elementum blandit vel in orci. Donec sit amet nisl ac eros mollis molestie. Curabitur ut urna vitae turpis bibendum malesuada sit amet imperdiet orci. Etiam pulvinar quam at lorem pellentesque congue. Integer sed odio enim. Maecenas eu nulla justo. Sed quis enim in est sodales facilisis non sed erat. Aenean vel ornare urna. Praesent viverra volutpat ex a aliquet.",
                        fontSize: 15,
                        margin: [0, 0, 0, 15]
                    }, {
                        text: "Fusce sed quam pharetra, ornare ligula id, maximus risus. Integer dignissim risus in placerat mattis. Fusce malesuada dui ut lectus ultricies, et sollicitudin nisl placerat. In dignissim elit in pretium lobortis. Fusce ornare enim at metus laoreet, ut convallis elit lacinia. Maecenas pharetra aliquet mi. Nulla orci nunc, egestas id nisi ut, volutpat sollicitudin mi.",
                        fontSize: 15,
                        margin: [0, 0, 0, 15]
                    }],
                    width: "*"
                }],
                columnGap: 30
            });

            doc.styles = {
                tHeader: {
                    fontSize: 8,
                    bold: false,
                    padding: [2, 2, 2, 2]
                },
                anotherStyle: {
                    italics: true,
                    alignment: 'right'
                }
            }

            doc.defaultStyle = {
                fontSize: 10,
                bold: false
            }

            pdfMake.createPdf(doc).download("report.pdf");

        });
    }

    public showTabsListFunc = (): void =>{
        // if (!this.showTabsList) {
        //     this.showTabsList = true
        // }
        this.showTabsList = !this.showTabsList;
    }

    public savePDF2 = (): void =>{

        Promise.all([
            this.chart.exporting.pdfmake,
            this.chart.exporting.getImage("png"),
            // chart2.exporting.getImage("png"),
            // chart3.exporting.getImage("png"),
            // chart4.exporting.getImage("png")
        ]).then((res) =>{

            let pdfMake = res[0];


            let docDefinition = {
                content: [
                    {text: 'Tables', style: 'header'},
                    'Official documentation is in progress, this document is just a glimpse of what is possible with pdfmake and its layout engine.',
                    {text: 'A simple table (no headers, no width specified, no spans, no styling)', style: 'subheader'},
                    'The following table has nothing more than a body array',
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                ['Column 1', 'Column 2', 'Column 3'],
                                ['One value goes here', 'Another one here', 'OK?']
                            ]
                        }
                    },
                    {text: 'A simple table with nested elements', style: 'subheader'},
                    'It is of course possible to nest any other type of nodes available in pdfmake inside table cells',
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                ['Column 1', 'Column 2', 'Column 3'],
                                [
                                    {
                                        stack: [
                                            'Let\'s try an unordered list',
                                            {
                                                ul: [
                                                    'item 1',
                                                    'item 2'
                                                ]
                                            }
                                        ]
                                    },
                                    [
                                        'or a nested table',
                                        {
                                            table: {
                                                body: [
                                                    ['Col1', 'Col2', 'Col3'],
                                                    ['1', '2', '3'],
                                                    ['1', '2', '3']
                                                ]
                                            },
                                        }
                                    ],
                                    {
                                        text: [
                                            'Inlines can be ',
                                            {text: 'styled\n', italics: true},
                                            {text: 'easily as everywhere else', fontSize: 10}]
                                    }
                                ]
                            ]
                        }
                    },
                    {text: 'Defining column widths', style: 'subheader'},
                    'Tables support the same width definitions as standard columns:',
                    {
                        bold: true,
                        ul: [
                            'auto',
                            'star',
                            'fixed value'
                        ]
                    },
                    {
                        style: 'tableExample',
                        table: {
                            widths: [100, '*', 200, '*'],
                            body: [
                                ['width=100', 'star-sized', 'width=200', 'star-sized'],
                                ['fixed-width cells have exactly the specified width', {
                                    text: 'nothing interesting here',
                                    italics: true,
                                    color: 'gray'
                                }, {
                                    text: 'nothing interesting here',
                                    italics: true,
                                    color: 'gray'
                                }, {text: 'nothing interesting here', italics: true, color: 'gray'}]
                            ]
                        }
                    },
                    {
                        style: 'tableExample',
                        table: {
                            widths: ['*', 'auto'],
                            body: [
                                ['This is a star-sized column. The next column over, an auto-sized column, will wrap to accomodate all the text in this cell.', 'I am auto sized.'],
                            ]
                        }
                    },
                    {
                        style: 'tableExample',
                        table: {
                            widths: ['*', 'auto'],
                            body: [
                                ['This is a star-sized column. The next column over, an auto-sized column, will not wrap to accomodate all the text in this cell, because it has been given the noWrap style.', {
                                    text: 'I am auto sized.',
                                    noWrap: true
                                }],
                            ]
                        }
                    },
                    {text: 'Defining row heights', style: 'subheader'},
                    {
                        style: 'tableExample',
                        table: {
                            heights: [20, 50, 70],
                            body: [
                                ['row 1 with height 20', 'column B'],
                                ['row 2 with height 50', 'column B'],
                                ['row 3 with height 70', 'column B']
                            ]
                        }
                    },
                    'With same height:',
                    {
                        style: 'tableExample',
                        table: {
                            heights: 40,
                            body: [
                                ['row 1', 'column B'],
                                ['row 2', 'column B'],
                                ['row 3', 'column B']
                            ]
                        }
                    },
                    'With height from function:',
                    {
                        style: 'tableExample',
                        table: {
                            heights: function (row){
                                return (row + 1) * 25;
                            },
                            body: [
                                ['row 1', 'column B'],
                                ['row 2', 'column B'],
                                ['row 3', 'column B']
                            ]
                        }
                    },
                    {text: 'Column/row spans', pageBreak: 'before', style: 'subheader'},
                    'Each cell-element can set a rowSpan or colSpan',
                    {
                        style: 'tableExample',
                        color: '#444',
                        table: {
                            widths: [200, 'auto', 'auto'],
                            headerRows: 2,
                            // keepWithHeaderRows: 1,
                            body: [
                                [{
                                    text: 'Header with Colspan = 2',
                                    style: 'tableHeader',
                                    colSpan: 2,
                                    alignment: 'center'
                                }, {}, {text: 'Header 3', style: 'tableHeader', alignment: 'center'}],
                                [{text: 'Header 1', style: 'tableHeader', alignment: 'center'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader',
                                    alignment: 'center'
                                }, {text: 'Header 3', style: 'tableHeader', alignment: 'center'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                [{
                                    rowSpan: 3,
                                    text: 'rowSpan set to 3\nLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor'
                                }, 'Sample value 2', 'Sample value 3'],
                                ['', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', {
                                    colSpan: 2,
                                    rowSpan: 2,
                                    text: 'Both:\nrowSpan and colSpan\ncan be defined at the same time'
                                }, ''],
                                ['Sample value 1', '', ''],
                            ]
                        }
                    },
                    {text: 'Headers', pageBreak: 'before', style: 'subheader'},
                    'You can declare how many rows should be treated as a header. Headers are automatically repeated on the following pages',
                    {
                        text: ['It is also possible to set keepWithHeaderRows to make sure there will be no page-break between the header and these rows. Take a look at the document-definition and play with it. If you set it to one, the following table will automatically start on the next page, since there\'s not enough space for the first row to be rendered here'],
                        color: 'gray',
                        italics: true
                    },
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            // dontBreakRows: true,
                            // keepWithHeaderRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                [
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                                ]
                            ]
                        }
                    },
                    {text: 'Styling tables', style: 'subheader'},
                    'You can provide a custom styler for the table. Currently it supports:',
                    {
                        ul: [
                            'line widths',
                            'line colors',
                            'cell paddings',
                        ]
                    },
                    'with more options coming soon...\n\npdfmake currently has a few predefined styles (see them on the next page)',
                    {text: 'noBorders:', fontSize: 14, bold: true, pageBreak: 'before', margin: [0, 0, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: 'noBorders'
                    },
                    {text: 'headerLineOnly:', fontSize: 14, bold: true, margin: [0, 20, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: 'headerLineOnly'
                    },
                    {text: 'lightHorizontalLines:', fontSize: 14, bold: true, margin: [0, 20, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: 'lightHorizontalLines'
                    },
                    {text: 'but you can provide a custom styler as well', margin: [0, 20, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node){
                                return (i === 0 || i === node.table.body.length) ? 2 : 1;
                            },
                            vLineWidth: function (i, node){
                                return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                            },
                            hLineColor: function (i, node){
                                return (i === 0 || i === node.table.body.length) ? 'black' : 'gray';
                            },
                            vLineColor: function (i, node){
                                return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
                            },
                            // hLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                            // paddingLeft: function(i, node) { return 4; },
                            // paddingRight: function(i, node) { return 4; },
                            // paddingTop: function(i, node) { return 2; },
                            // paddingBottom: function(i, node) { return 2; },
                            // fillColor: function (rowIndex, node, columnIndex) { return null; }
                        }
                    },
                    {text: 'zebra style', margin: [0, 20, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: {
                            fillColor: function (rowIndex, node, columnIndex){
                                return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                            }
                        }
                    },
                    {text: 'and can be used dash border', margin: [0, 20, 0, 8]},
                    {
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: [
                                [{text: 'Header 1', style: 'tableHeader'}, {
                                    text: 'Header 2',
                                    style: 'tableHeader'
                                }, {text: 'Header 3', style: 'tableHeader'}],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                                ['Sample value 1', 'Sample value 2', 'Sample value 3'],
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node){
                                return (i === 0 || i === node.table.body.length) ? 2 : 1;
                            },
                            vLineWidth: function (i, node){
                                return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                            },
                            hLineColor: function (i, node){
                                return 'black';
                            },
                            vLineColor: function (i, node){
                                return 'black';
                            },
                            hLineStyle: function (i, node){
                                if (i === 0 || i === node.table.body.length){
                                    return null;
                                }
                                return {dash: {length: 10, space: 4}};
                            },
                            vLineStyle: function (i, node){
                                if (i === 0 || i === node.table.widths.length){
                                    return null;
                                }
                                return {dash: {length: 4}};
                            },
                            // paddingLeft: function(i, node) { return 4; },
                            // paddingRight: function(i, node) { return 4; },
                            // paddingTop: function(i, node) { return 2; },
                            // paddingBottom: function(i, node) { return 2; },
                            // fillColor: function (i, node) { return null; }
                        }
                    },
                    {text: 'Optional border', fontSize: 14, bold: true, pageBreak: 'before', margin: [0, 0, 0, 8]},
                    'Each cell contains an optional border property: an array of 4 booleans for left border, top border, right border, bottom border.',
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                [
                                    {
                                        border: [false, true, false, false],
                                        fillColor: '#eeeeee',
                                        text: 'border:\n[false, true, false, false]'
                                    },
                                    {
                                        border: [false, false, false, false],
                                        fillColor: '#dddddd',
                                        text: 'border:\n[false, false, false, false]'
                                    },
                                    {
                                        border: [true, true, true, true],
                                        fillColor: '#eeeeee',
                                        text: 'border:\n[true, true, true, true]'
                                    }
                                ],
                                [
                                    {
                                        rowSpan: 3,
                                        border: [true, true, true, true],
                                        fillColor: '#eeeeff',
                                        text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                                    },
                                    {
                                        border: undefined,
                                        fillColor: '#eeeeee',
                                        text: 'border:\nundefined'
                                    },
                                    {
                                        border: [true, false, false, false],
                                        fillColor: '#dddddd',
                                        text: 'border:\n[true, false, false, false]'
                                    }
                                ],
                                [
                                    '',
                                    {
                                        colSpan: 2,
                                        border: [true, true, true, true],
                                        fillColor: '#eeffee',
                                        text: 'colSpan: 2\n\nborder:\n[true, true, true, true]'
                                    },
                                    ''
                                ],
                                [
                                    '',
                                    {
                                        border: undefined,
                                        fillColor: '#eeeeee',
                                        text: 'border:\nundefined'
                                    },
                                    {
                                        border: [false, false, true, true],
                                        fillColor: '#dddddd',
                                        text: 'border:\n[false, false, true, true]'
                                    }
                                ]
                            ]
                        },
                        layout: {
                            defaultBorder: false,
                        }
                    },
                    'For every cell without a border property, whether it has all borders or not is determined by layout.defaultBorder, which is false in the table above and true (by default) in the table below.',
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                [
                                    {
                                        border: [false, false, false, false],
                                        fillColor: '#eeeeee',
                                        text: 'border:\n[false, false, false, false]'
                                    },
                                    {
                                        fillColor: '#dddddd',
                                        text: 'border:\nundefined'
                                    },
                                    {
                                        fillColor: '#eeeeee',
                                        text: 'border:\nundefined'
                                    },
                                ],
                                [
                                    {
                                        fillColor: '#dddddd',
                                        text: 'border:\nundefined'
                                    },
                                    {
                                        fillColor: '#eeeeee',
                                        text: 'border:\nundefined'
                                    },
                                    {
                                        border: [true, true, false, false],
                                        fillColor: '#dddddd',
                                        text: 'border:\n[true, true, false, false]'
                                    },
                                ]
                            ]
                        }
                    },
                    'And some other examples with rowSpan/colSpan...',
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                [
                                    '',
                                    'column 1',
                                    'column 2',
                                    'column 3'
                                ],
                                [
                                    'row 1',
                                    {
                                        rowSpan: 3,
                                        colSpan: 3,
                                        border: [true, true, true, true],
                                        fillColor: '#cccccc',
                                        text: 'rowSpan: 3\ncolSpan: 3\n\nborder:\n[true, true, true, true]'
                                    },
                                    '',
                                    ''
                                ],
                                [
                                    'row 2',
                                    '',
                                    '',
                                    ''
                                ],
                                [
                                    'row 3',
                                    '',
                                    '',
                                    ''
                                ]
                            ]
                        },
                        layout: {
                            defaultBorder: false,
                        }
                    },
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                [
                                    {
                                        colSpan: 3,
                                        text: 'colSpan: 3\n\nborder:\n[false, false, false, false]',
                                        fillColor: '#eeeeee',
                                        border: [false, false, false, false]
                                    },
                                    '',
                                    ''
                                ],
                                [
                                    'border:\nundefined',
                                    'border:\nundefined',
                                    'border:\nundefined'
                                ]
                            ]
                        }
                    },
                    {
                        style: 'tableExample',
                        table: {
                            body: [
                                [
                                    {
                                        rowSpan: 3,
                                        text: 'rowSpan: 3\n\nborder:\n[false, false, false, false]',
                                        fillColor: '#eeeeee',
                                        border: [false, false, false, false]
                                    },
                                    'border:\nundefined',
                                    'border:\nundefined'
                                ],
                                [
                                    '',
                                    'border:\nundefined',
                                    'border:\nundefined'
                                ],
                                [
                                    '',
                                    'border:\nundefined',
                                    'border:\nundefined'
                                ]
                            ]
                        }
                    },
                    {text: 'BorderColor per Cell with Column/row spans', pageBreak: 'before', style: 'subheader'},
                    'Each cell-element can set the borderColor (the cell above or left of the current cell has priority',
                    {
                        style: 'tableExample',
                        color: '#444',
                        table: {
                            widths: [200, 'auto', 'auto'],
                            headerRows: 2,
                            // keepWithHeaderRows: 1,
                            body: [
                                [
                                    {
                                        text: 'Header with Colspan = 3',
                                        style: 'tableHeader',
                                        colSpan: 3,
                                        borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                        alignment: 'center',
                                    },
                                    {},
                                    {},
                                ],
                                [
                                    {
                                        text: 'Header 1',
                                        style: 'tableHeader',
                                        alignment: 'center',
                                    },
                                    {
                                        text: 'Header 2',
                                        style: 'tableHeader',
                                        alignment: 'center',
                                    },
                                    {
                                        text: 'Header 3',
                                        style: 'tableHeader',
                                        alignment: 'center',
                                    },
                                ],
                                [
                                    'Sample value 1',
                                    'Sample value 2',
                                    'Sample value 3',
                                ],
                                [
                                    {
                                        rowSpan: 3,
                                        borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                        text: 'rowSpan set to 3\nLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor',
                                    },
                                    'Sample value 2',
                                    {
                                        text: 'Sample value 3',
                                        borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                    },
                                ],
                                [
                                    '',
                                    'Sample value 2',
                                    'Sample value 3',
                                ],
                                [
                                    'Sample value 1',
                                    'Sample value 2',
                                    'Sample value 3',
                                ],
                                [
                                    'Sample value 1',
                                    {
                                        colSpan: 2,
                                        rowSpan: 2,
                                        borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                        text: 'Both:\nrowSpan and colSpan\ncan be defined at the same time',
                                    },
                                    '',
                                ],
                                [
                                    'Sample value 1',
                                    {
                                        text: 'a', borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                    },
                                    {
                                        text: '',
                                        borderColor: ['#ff00ff', '#00ffff', '#ff00ff', '#00ffff'],
                                    },
                                ],
                            ],
                        },
                    },
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                },
                defaultStyle: {
                    // alignment: 'justify'
                }
            };

            pdfMake.createPdf(docDefinition).download("report.pdf");

        });
    }

    private lineTable = (): { tWidth: string[], tBody: any[] }[] =>{
        //let tHeader: any [] = [];
        let fullInfo = this.info.concat(this.infoBubble);

        const formTable = (info: ChartLineModel[]): { tWidth: string[], tBody: any[] } =>{
            let tHeader = info.map(item =>{
                return {text: item.lineName, bold: true, style: 'tHeader'}
            });

            tHeader.unshift({text: this.translates.Date, bold: true, style: 'tHeader'});
            let tWidth: any[] = info.map(item => 30);
            tWidth.unshift('auto');

            let tBody: any[] = [];

            tBody.push(tHeader);

            let tData = this.chartData.rows.map(item =>{
                let row: any[] = [];
                row.push(Formatters.dateFormatterConv(null, null, item.date));
                info.forEach(inItem =>{
                    row.push(item[inItem.name]);
                });
                return row;
            });

            tBody = tBody.concat(tData);
            return {tWidth: tWidth, tBody: tBody};
        };

        let res: { tWidth: string[], tBody: any[] }[] = [];

        let half = fullInfo.length / 2;

        // console.log(fullInfo.length / 2, Math.round(fullInfo.length / 2))

        res.push(formTable(fullInfo.filter((item, i) => i < Math.round(fullInfo.length / 2))));
        res.push(formTable(fullInfo.filter((item, i) => i >= Math.round(fullInfo.length / 2))));
        return res;


    }

}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/amchart4.component/amchart4.component.ts